import React from 'react'
import PropTypes from 'prop-types'
import CurrencyTextBoxRegular from './currency_text_box_regular'
import { getDecimalPrecision, getDecimalSeparator } from 'client/griffin'

class CurrencyTextBox extends React.Component {
  static propTypes = {
    currencyCode: PropTypes.string,
    decimalDigits: PropTypes.number,
    decimalDot: PropTypes.string,
  }

  render() {
    let { ...propsToPass } = this.props

    Object.assign(propsToPass, {
      decimalDigits:
        this.props.decimalDigits != null
          ? this.props.decimalDigits
          : getDecimalPrecision(this.props.currencyCode),
      decimalDot:
        this.props.decimalDot != null
          ? this.props.decimalDot
          : getDecimalSeparator(this.props.currencyCode),
    })

    return <CurrencyTextBoxRegular {...propsToPass} />
  }
}

export default CurrencyTextBox
